import { render } from "./printStock.vue?vue&type=template&id=be3fb5a2&scoped=true"
import script from "./printStock.vue?vue&type=script&lang=js"
export * from "./printStock.vue?vue&type=script&lang=js"

import "./printStock.vue?vue&type=style&index=0&id=be3fb5a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be3fb5a2"

export default script